import { memo } from "react";
import { useTranslation } from "react-i18next";
import { FeedCurveMilestone } from "../../../../Services/Agrisys_GqlDataCaller/FeedDataCalls/GQLCalls/getFeedCurvesCall";
import CurveInfoBox from "../../curveInfoBox";

const InfoBoxMilestones = memo(({ milestones }: { milestones: FeedCurveMilestone[] | undefined }) => {
  const { t } = useTranslation();

  const displayData = Object.fromEntries(
    ([...milestones ?? []])
    .sort((a, b) => a.milestoneIndex - b.milestoneIndex)
    .map((milestone, index) => [
        `M${index + 1}`,
        { value: milestone.name }
      ])
  );

  return (
    <CurveInfoBox
      header={t("milestones.general.milestones", {defaultValue: "Milestones"})}
      data={{
        displayData: displayData
      }}
    />
  )
})

export default InfoBoxMilestones